module.exports = __webpack_public_path__ + "img/FACeB2B.8756f7a1.png";